import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0C] px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-dark w-full max-w-md p-8">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#D4AF37]/15 text-[#D4AF37]"><Lock size={22} /></div>
          <h1 className="font-serif text-2xl font-bold gold-text">SIRAKH CREATIONS</h1>
          <p className="mt-1 text-sm text-zinc-500">Admin Dashboard</p>
        </div>
        <div className="space-y-4">
          <div>
            <label className="caption mb-2 block">Email</label>
            <input className="input-field" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          </div>
          <div>
            <label className="caption mb-2 block">Password</label>
            <input className="input-field" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="admin-login-submit-button">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "SIGN IN"}
          </button>
        </div>
      </form>
    </div>
  );
}
